/**
 * Platform-wide constants shared between the server and client.
 * Import from here to avoid version drift between independent modules.
 */

/** Version string for the current Terms of Service. Update this whenever
 *  the ToS is materially revised so all gates and comparisons stay in sync. */
export const CURRENT_TOS_VERSION = "2026-06";
